module.exports = __webpack_public_path__ + "img/2.66635671.png";